/*
* *********************************************************************************************************************
*  * © 2026 Fannie Mae. All rights reserved.
*  * This software may contain confidential information of Fannie Mae.
*  * Use, disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.
*  * ********************************************************************************************************************
*/

import('./bootstrap')
	.catch(err => console.error(err));
